import { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import "../../pages/mondoub pages/home-page/components/transaction-contributions/contribution.css";
import { BiDollar } from 'react-icons/bi';
import { GoGift } from 'react-icons/go';
import { useFetchData } from '../../hooks/useFetchData';

function SalaryChart() {
  const { data: salarydata, loading, error } = useFetchData("mandoub/contributions");

  const [state, setState] = useState({
    series: [
      {
        type: 'line',
        name: 'المكافأة', // "Bonus" in Arabic
        data: [0, 0, 0, 0, 0], // Default to empty values
      },
      {
        type: 'line',
        name: 'الراتب', // "Salary" in Arabic
        data: [0, 0, 0, 0, 0], // Default to empty values
      },
    ],
    options: {
      chart: {
        stacked: false,
        parentHeightOffset: 0,
        toolbar: { show: false },
      },
      markers: {
        size: 4,
        strokeWidth: 3,
        fillOpacity: 1,
        strokeOpacity: 1,
        colors: 'white',
        strokeColors: 'var(--primary)',
      },
      stroke: {
        curve: 'smooth',
        width: [3, 3],
        colors: ['var(--cyan)', 'var(--cyan-light)'],
      },
      dataLabels: { enabled: false },
      states: {
        hover: {
          filter: { type: 'none' },
        },
        active: {
          filter: { type: 'none' },
        },
      },
      legend: { show: true },
      grid: {
        yaxis: {
          lines: { show: false },
        },
        padding: {
          top: -26,
          left: -14,
          right: -16,
          bottom: -8,
        },
      },
      xaxis: {
        axisTicks: { show: false },
        axisBorder: { show: false },
        categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو'], // Arabic Months
        labels: {
          style: { colors: 'var(--text)', fontSize: '13px' },
        },
      },
      yaxis: {
        max: 2000, // Adjusted max value for salary visualization
        min: 0,
        show: true,
      },
    },
  });

  useEffect(() => {
    if (salarydata && salarydata.salaryStats && Array.isArray(salarydata.salaryStats.recentSalaries)) {
      const recentSalaries = salarydata.salaryStats.recentSalaries;
      const salaryData = recentSalaries.map(item => item.salary || 0); // Default to 0 if salary is undefined or null
      const bonusData = recentSalaries.map(item => item.bonus || 0); // Default to 0 if bonus is undefined or null

      setState(prevState => ({
        ...prevState,
        series: [
          { ...prevState.series[0], data: bonusData },
          { ...prevState.series[1], data: salaryData },
        ],
      }));
    }
  }, [salarydata]);

  const totalSalary = salarydata?.salaryStats?.totalSalary ?? 0; // Default to 0 if undefined or null
  const totalBonus = salarydata?.salaryStats?.totalBonus ?? 0; // Default to 0 if undefined or null

  // If loading or error, return a loading state or fallback content
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading data</div>;
  }

  return (
    <div className='section-card flex1 !w-1/2 sm-w-full' style={{ borderRadius: "1rem"}} dir='rtl'>
      <div id='chart' className='w-full df-c g0'>
        <div dir='rtl' className='df-c'>
            <div className="title">الراتب</div> {/* "salary" in Arabic */}
            <div className="df-c">
              <div className="df !gap-2">
                <div className="rounded-icon !w-10 !h-10 !rounded-md">
                    <BiDollar />
                </div>
                <div className="df-c g0">
                  <div className='text-black font-bold'>{totalSalary} ﷼</div>
                  <div className='text'>إجمالي الراتب</div> {/* "total salary" in Arabic */}
                </div>
                
              </div>
              <div className="df">
                <div className="rounded-icon purpled !w-10 !h-10 !rounded-md">
                    <GoGift />
                </div>
                <div className="df-c g0">
                  <div className='text-black font-bold'>{totalBonus} ﷼</div>
                  <div className='text'>إجمالي المكافأة</div> {/* "total bonus" in Arabic */}
                </div>
                
              </div>
            </div>
        </div>
        <ReactApexChart className="m-auto" type='line' height={200} style={{ width: "100%" }} series={state.series} options={state.options} />
      </div>
    </div>
  );
}

export default SalaryChart;
